<template>
  <div :class="classList" @click="onClick">
    <component :is="icon" />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
export default {
  name: "st-icon",
  props: {
    name: {
      type: String,
      required: true,
    },

    inline: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: "md",
      validator: function (size) {
        return ["xs", "sm", "md", "lg", "custom"].includes(size);
      },
    },
    useSvg: {
      type: Boolean,
      default: false,
    },
    click: {
      type: Function,
    },
    item: {
      type: Object,
    },
    alt: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: Array,
      required: false,
      default: () => [],
    },
    org: {
      type: String,
      default: "st",
    },
  },
  computed: {
    classList: function () {
      return [
        ...this.classes,
        "st-icon",
        this.name,
        this.size,
        this.org,
        this.inline && "inline",
        this.disabled && "disabled",
      ];
    },
    icon() {
      if (this.name) {
        return defineAsyncComponent(() =>
          import(`../../icons/${this.org}/${this.name}.vue`)
        );
      }
      return null;
    },
  },

  methods: {
    onClick: function () {
      if (this.click && !this.disabled) this.click(this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  background-repeat: no-repeat;
  background-position: center;
  &.st-icon {
    display: block;
    position: relative;
    & > svg {
      width: inherit;
      height: inherit;
    }
    &.xs {
      background-size: 0.75em 0.75em;
      width: 0.75em;
      height: 0.75em;
    }
    &.sm {
      background-size: 1.25em 1.25em;
      width: 1.25em;
      height: 1.25em;
    }

    &.md {
      background-size: 1.5em 1.5em;
      width: 1.5em;
      height: 1.5em;
    }

    &.lg {
      background-size: 2.25em 2.25em;
      width: 2.25em;
      height: 2.25em;
    }

    &.inline {
      display: inline-flex;
      justify-content: center;
      vertical-align: middle;
    }

    &.ot {
      &.child {
        transform: scale(0.8);
      }
    }
  }

  &.disabled {
    opacity: 0.5;
  }
}
</style>
